import * as ActionGenerics from "../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";
import * as LocationTypes from "../DataTypes/locationTypes";

export const locations = (
    state: LocationTypes.ILocation[],
    action: ActionGenerics.IAction<ActionTypes.Actions>
): LocationTypes.ILocation[] => {
    switch (action.type) {
        case ActionTypes.Actions.UpdateLocations: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, LocationTypes.ILocation[]>;

            return data.parameter;
        }

        default:
            return state;
    }
};
